module.exports = __webpack_public_path__ + "assets/img/sabc_tv_schedule_sport_sabc.svg?34bcbbdb9f3936d33d0ca8ce8ee7d85e";